import React from 'react';
import { Box, Inline, Stack } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { boxStyles } from '../constants/styles';

const renderBoxHeading = (headingWidth?: string, actionWidth?: string) => {
  return (
    <SkeletonLoaderWrapper>
      <SkeletonLoader width={headingWidth ?? '30%'} />
      <SkeletonLoader isRightAligned width={actionWidth ?? '10%'} />
    </SkeletonLoaderWrapper>
  );
};

const renderTabs = (width?: string) => {
  return (
    <SkeletonLoaderWrapper>
      <SkeletonLoader width={width ?? '18%'} />
      <SkeletonLoader width={width ?? '18%'} />
    </SkeletonLoaderWrapper>
  );
};

export const HomePageBoxLoader = () => {
  const arrayLength = 6;

  return (
    <>
      {Array.from({ length: arrayLength }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SkeletonLoaderWrapper key={index}>
          <SkeletonLoaderWrapper>
            <SkeletonLoader width="40%" marginBottom="8px" />
            <SkeletonLoader isRightAligned width="20%" marginBottom="8px" />
          </SkeletonLoaderWrapper>
          <SkeletonLoaderWrapper>
            <SkeletonLoader width="15%" height="10px" marginBottom="8px" />
            <SkeletonLoader isRightAligned width="40%" height="10px" marginBottom="8px" />
          </SkeletonLoaderWrapper>
          {index === arrayLength - 1 || <SkeletonLoader height="1px" marginBottom="8px" />}
        </SkeletonLoaderWrapper>
      ))}
    </>
  );
};

const HomePageBoxLoaderContainer = () => {
  return (
    <Box padding="space.250" xcss={boxStyles}>
      {renderBoxHeading('24%', '15%')}
      {renderTabs('30%')}
      <br />
      <HomePageBoxLoader />
    </Box>
  );
};

export const HomePageLoader = ({ hideHeader, hideBody }: { hideHeader?: boolean; hideBody?: boolean }) => {
  return (
    <div className="pl-8">
      {hideHeader || <PageHeaderLoader hideActions />}
      {hideBody || (
        <>
          <Stack space="space.100">
            <Inline space="space.300">
              <HomePageBoxLoaderContainer />
              <HomePageBoxLoaderContainer />
            </Inline>
            <Box padding="space.250" xcss={boxStyles}>
              {/* Subscription section */}
              {renderBoxHeading()}
              {renderTabs()}
              <br />
              <TableLoader hideActions hideSearchBar hideFilters columnsCount={6} />
            </Box>
          </Stack>
          <br />
        </>
      )}
    </div>
  );
};
